<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LWuJ17/tc-custom/9781528982672.jpg?1726273280655" alt="This image is the cover for the book Finding Magic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finding Magic
      </h1>
      <p class="bookDescription body article font2">
        <p>In the picturesque setting of the Devon Moors, Magic, a lonely pony, waits for his cherished owner, Victoria, unaware of the tragedy that has struck the Dixon family. Lizzy, a newcomer to the area, stumbles upon this neglected pony during her explorations of the countryside. At the sound of her voice, Magic’s ears perk up, signalling the beginning of a new chapter. Lizzy, moved by his plight, names him Magic and embarks on a quest to uncover his past. Her journey leads her to the heart-wrenching reason behind his abandonment. As Lizzy forges a deep connection with Magic, they encounter resistance from those who disapprove of their bond. Together, they navigate challenges brimming with danger and adversity, testing the strength of their newfound friendship. This heartwarming story is a testament to the power of compassion and the unbreakable bonds formed in the face of hardship.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stella Perrott
      </h2>
      
      <p class="authorDescription body article">Stella Perrott grew up in the beautiful African country, Zimbabwe. Some of her fondest memories are evenings spent with family around a log fire under the African sky. Stella then moved to Australia, where she now lives close to her daughters and granddaughters. Her mature years have given her the opportunity to share life’s experiences, ensuring the humour and adventure of this world is not forgotten. Enjoy the escapism of Stella’s fresh uplifting fiction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00b3f41a